function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9,7 C7.343,7 6,8.343 6,10 C6,11.657 7.343,13 9,13 C10.657,13 12,11.657 12,10 C12,8.343 10.657,7 9,7 M2,12 C0.896,12 0,12.896 0,14 C0,15.104 0.896,16 2,16 C3.104,16 4,15.104 4,14 C4,12.896 3.104,12 2,12 M2,4 C0.896,4 0,4.896 0,6 C0,7.104 0.896,8 2,8 C3.104,8 4,7.104 4,6 C4,4.896 3.104,4 2,4 M16,12 C14.896,12 14,12.896 14,14 C14,15.104 14.896,16 16,16 C17.104,16 18,15.104 18,14 C18,12.896 17.104,12 16,12 M9,16 C7.896,16 7,16.896 7,18 C7,19.104 7.896,20 9,20 C10.104,20 11,19.104 11,18 C11,16.896 10.104,16 9,16 M9,0 C7.896,0 7,0.896 7,2 C7,3.104 7.896,4 9,4 C10.104,4 11,3.104 11,2 C11,0.896 10.104,0 9,0 M18,6 C18,7.104 17.104,8 16,8 C14.896,8 14,7.104 14,6 C14,4.896 14.896,4 16,4 C17.104,4 18,4.896 18,6",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-1 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/channels.6d25263c.svg";
export { SvgComponent as ReactComponent };